// The internal theme is only for white-label internal use and not part of the
// API. We may decide to move some of these values into  the API at a later point.
// The tokens and breakpoints are so far based on/copied from the VW tokens and
// breakpoints.

const InternalBreakpoints = {
  default: 0,
  b560: 560,
  b960: 960,
  b1280: 1280,
  b1600: 1600,
  b1920: 1920,
  b2560: 2560,
};

export const Breakpoints = {
  default: InternalBreakpoints.default,
  twoColumnLayout: InternalBreakpoints.b960,
};

export const _dontImportMeInternalTheme = {
  global: {
    backgroundColor: '#ffffff',
    shimColor: 'rgba(0, 0, 0, 0.5)',
    eyeCatcherColor: '#00E6E6',
  },
  separatorColor: '#DFE4E8',
  Breakpoints: InternalBreakpoints,
  size: {
    line: {
      default: '1px',
      active: '2px',
    },
    border: {
      light: '1px',
      heavy: '2px',
    },
    static0: '0',
    static100: '4px',
    static150: '8px',
    static200: '12px',
    static250: '16px',
    static300: '20px',
    static350: '24px',
    static370: '28px',
    static400: '32px',
    static450: '40px',
    static500: '44px',
    static510: '48px',
    static515: '52px',
    static520: '56px',
    static530: '64px',
    static535: '68px',
    static550: '72px',
    static565: '80px',
    static575: '84px',
    static600: '92px',
    grid001: 'var(--e-mobility-size-grid001)',
    grid002: 'var(--e-mobility-size-grid002)',
    grid003: 'var(--e-mobility-size-grid003)',
    grid004: 'var(--e-mobility-size-grid004)',
    grid005: 'var(--e-mobility-size-grid005)',
    grid006: 'var(--e-mobility-size-grid006)',
    grid007: 'var(--e-mobility-size-grid007)',
    grid008: 'var(--e-mobility-size-grid008)',
    grid009: 'var(--e-mobility-size-grid009)',
    grid010: 'var(--e-mobility-size-grid010)',
    grid011: 'var(--e-mobility-size-grid011)',
    grid012: 'var(--e-mobility-size-grid012)',
    grid013: 'var(--e-mobility-size-grid013)',
    grid014: 'var(--e-mobility-size-grid014)',
    grid015: 'var(--e-mobility-size-grid015)',
    grid016: 'var(--e-mobility-size-grid016)',
    grid017: 'var(--e-mobility-size-grid017)',
    grid018: 'var(--e-mobility-size-grid018)',
    grid019: 'var(--e-mobility-size-grid019)',
    grid020: 'var(--e-mobility-size-grid020)',
    grid021: 'var(--e-mobility-size-grid021)',
    grid022: 'var(--e-mobility-size-grid022)',
    grid023: 'var(--e-mobility-size-grid023)',
    grid024: 'var(--e-mobility-size-grid024)',
    dynamic0020: 'var(--e-mobility-size-dynamic0020)',
    dynamic0040: 'var(--e-mobility-size-dynamic0040)',
    dynamic0050: 'var(--e-mobility-size-dynamic0050)',
    dynamic0100: 'var(--e-mobility-size-dynamic0100)',
    dynamic0120: 'var(--e-mobility-size-dynamic0120)',
    dynamic0130: 'var(--e-mobility-size-dynamic0130)',
    dynamic0140: 'var(--e-mobility-size-dynamic0140)',
    dynamic0150: 'var(--e-mobility-size-dynamic0150)',
    dynamic0200: 'var(--e-mobility-size-dynamic0200)',
    dynamic0250: 'var(--e-mobility-size-dynamic0250)',
    dynamic0270: 'var(--e-mobility-size-dynamic0270)',
    dynamic0300: 'var(--e-mobility-size-dynamic0300)',
    dynamic0350: 'var(--e-mobility-size-dynamic0350)',
    dynamic0450: 'var(--e-mobility-size-dynamic0450)',
  },
  interaction: {
    recipe100: {
      default: '#000000',
      hover: '#6A767D',
      active: '#6A767D',
      disabled: '#DFE4E8',
      checked: '#000000',
    },
    recipe150: {
      default: '#DFE4E8',
      hover: '#DFE4E8',
      active: '#DFE4E8',
      disabled: '#DFE4E8',
      checked: '#001E50',
    },
    recipe200: {
      default: '#6A767D',
      hover: '#96A3A8',
      active: '#96A3A8',
      disabled: '#DFE4E8',
      checked: '#001E50',
    },
    recipe250: {
      default: '#00B0F0',
      hover: '#4CC7F4',
      active: '#4CC7F4',
      disabled: '#DFE4E8',
      checked: '#00B0F0',
    },
    recipe300: {
      default: '#001E50',
      hover: '#001E50',
      active: '#001E50',
      disabled: '#6A767D',
      checked: '#001E50',
    },
    recipe350: {
      default: '#008437',
      hover: '#ADE5A1',
      active: '#ADE5A1',
      disabled: '#008437',
      checked: '#008437',
    },
    recipe360: {
      default: '#E4002C',
      hover: '#FF335C',
      active: '#FF335C',
      disabled: '#E4002C',
      checked: '#E4002C',
    },
    recipe370: {
      default: '#5B08A4',
      hover: '#5B08A4',
      active: '#5B08A4',
      disabled: '#DFE4E8',
      checked: '#5B08A4',
    },
    recipe380: {
      default: '#FFD100',
      hover: '#FFD100',
      active: '#FFD100',
      disabled: '#DFE4E8',
      checked: '#FFD100',
    },
    recipe400: {
      default: '#001E50',
      hover: '#0040C5',
      active: '#0040C5',
      disabled: '#DFE4E8',
      checked: '#001E50',
    },
    recipe450: {
      default: '#001E50',
      hover: '#0040C5',
      active: '#0040C5',
      disabled: '#6A767D',
      checked: '#001E50',
    },
    recipe500: {
      default: '#001E50',
      hover: '#001E50',
      active: '#001E50',
      disabled: '#DFE4E8',
      checked: '#001E50',
    },
    recipe550: {
      default: '#C2CACF',
      hover: '#DFE4E8',
      active: '#DFE4E8',
      checked: '#C2CACF',
    },
    recipe600: {
      default: '#3C484D',
      hover: '#6A767D',
      active: '#6A767D',
      checked: '#3C484D',
    },
    recipe700: {
      default: '#DFE4E8',
      hover: '#6A767D',
      active: '#6A767D',
      disabled: '#DFE4E8',
      checked: '#001E50',
    },
    recipe750: {
      default: '#ffffff',
      hover: '#ffffff',
      active: '#ffffff',
      disabled: '#000000',
      checked: '#ffffff',
    },
    recipe800: {
      default: '#ffffff',
      hover: '#ffffff',
      active: '#ffffff',
      disabled: '#C2CACF',
      checked: '#001E50',
    },
    recipe850: {
      default: '#000000',
      hover: '#000000',
      active: '#000000',
      disabled: '#ffffff',
      checked: '#ffffff',
    },
    recipe925: {
      default: '#001E50',
      hover: '#0040C5',
      active: '#0040C5',
      disabled: '#C2CACF',
      checked: '#0040C5',
    },
    recipe950: {
      default: '#ffffff',
      hover: '#ffffff',
      active: '#ffffff',
      disabled: '#ffffff',
      checked: '#ffffff',
    },
  },
  hoverIndicatorColor: {
    filledElement: {
      default: 'rgba(255, 255, 255, 0.2)',
      active: 'rgba(255, 255, 255, 0.4)',
    },
    outlinedElement: {
      default: 'rgba(194, 202, 207, 0.2)',
      active: 'rgba(255, 255, 255, 0.2)',
    },
  },
  focus: {
    background: '#0077CC',
    foreground: '#ffffff',
  },
  border: {
    color: {
      primary: '#001E50',
      secondary: '#DFE4E8',
    },
  },
};

export const buildInternalThemeVariablesCss = (): string => `
  --e-mobility-size-dynamic0020:4px;
  --e-mobility-size-dynamic0040:12px;
  --e-mobility-size-dynamic0050:12px;
  --e-mobility-size-dynamic0100:20px;
  --e-mobility-size-dynamic0120:24px;
  --e-mobility-size-dynamic0130:24px;
  --e-mobility-size-dynamic0140:28px;
  --e-mobility-size-dynamic0150:28px;
  --e-mobility-size-dynamic0200:32px;
  --e-mobility-size-dynamic0250:44px;
  --e-mobility-size-dynamic0270:56px;
  --e-mobility-size-dynamic0300:72px;
  --e-mobility-size-dynamic0350:100px;
  --e-mobility-size-dynamic0450:156px;
 @media(min-width: ${InternalBreakpoints.b560}px) {
  --e-mobility-size-dynamic0020:4px;
  --e-mobility-size-dynamic0040:20px;
  --e-mobility-size-dynamic0050:20px;
  --e-mobility-size-dynamic0100:24px;
  --e-mobility-size-dynamic0120:20px;
  --e-mobility-size-dynamic0130:40px;
  --e-mobility-size-dynamic0140:32px;
  --e-mobility-size-dynamic0150:52px;
  --e-mobility-size-dynamic0200:56px;
  --e-mobility-size-dynamic0250:68px;
  --e-mobility-size-dynamic0270:80px;
  --e-mobility-size-dynamic0300:96px;
  --e-mobility-size-dynamic0350:132px;
  --e-mobility-size-dynamic0450:172px;
 }
 @media(min-width: ${InternalBreakpoints.b1600}px) {
  --e-mobility-size-dynamic0020:8px;
  --e-mobility-size-dynamic0040:32px;
  --e-mobility-size-dynamic0050:24px;
  --e-mobility-size-dynamic0100:28px;
  --e-mobility-size-dynamic0120:20px;
  --e-mobility-size-dynamic0130:52px;
  --e-mobility-size-dynamic0140:48px;
  --e-mobility-size-dynamic0150:64px;
  --e-mobility-size-dynamic0200:72px;
  --e-mobility-size-dynamic0250:84px;
  --e-mobility-size-dynamic0270:100px;
  --e-mobility-size-dynamic0300:120px;
  --e-mobility-size-dynamic0350:196px;
  --e-mobility-size-dynamic0450:184px;
 }

  ${Array.from(
    {length: 24},
    (_, i) =>
      `--e-mobility-size-grid${(i + 1).toString().padStart(3, '0')}: ${
        Math.round((100 / 24) * (i + 1) * 100) / 100
      }vw;`
  ).join('\n')}

  @media(min-width: ${InternalBreakpoints.b2560}px) {
    --e-mobility-size-dynamic0040:48px;
    ${Array.from(
      {length: 24},
      (_, i) =>
        `--e-mobility-size-grid${(i + 1).toString().padStart(3, '0')}: ${
          (InternalBreakpoints.b2560 / 24) * (i + 1)
        }px;`
    ).join('\n')}
  }
`;

export type InternalTheme = typeof _dontImportMeInternalTheme;
